import React from 'react'
import PropTypes from 'prop-types'
import StreamInvoice from './StreamInvoice'
import { IS_HTML } from '../constants'
import { useMedia } from 'react-use'

const ResponsiveTable = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const DocIcon = <img src='/images/icon-document.svg' alt='View file' />
    const isPdfUrl = item => typeof (item) === 'string' && item.includes('http') && item.includes('pdf')
    const isPdfStream = item => typeof (item) === 'string' && item.includes('STREAM_INVOICE_')
    const isHtml = item => typeof (item) === 'string' && item.includes(IS_HTML)

    const handleOpenModel = (event, content) => {
        event.preventDefault()
        props.handleOpenModal(content.replace(IS_HTML, ''))
    }

    const content = (item) => {
        if (isPdfStream(item)) {
            return <StreamInvoice data={JSON.parse(item.replace('STREAM_INVOICE_', ''))}>{DocIcon}</StreamInvoice>
        } else if (isHtml(item)) {
            return <a href='#' onClick={event => handleOpenModel(event, item)}>{DocIcon}</a>
        } else if (isPdfUrl(item)) {
            return <a href={item} target='_blank'>{DocIcon}</a>
        } else if (Array.isArray(item)) {
            return item.map((value, key) => {
                return <div key={key} dangerouslySetInnerHTML={{ __html: value }} />
            })
        } else if (typeof item === 'object') {
            return <div>{item}</div>
        } else {
            return <div dangerouslySetInnerHTML={{ __html: item }} />
        }
    }

    return (
        <div className={`position-relative ${props.className}`}>
            <div className='responsive-table'>
                {/* DESKTOP */}
                <table style={(isMobile && props.minWidthMobile ? { minWidth: `${props.minWidthMobile}px` } : {})}>
                    <thead>
                        <tr>
                            {props.data.headings.map((item, key) => {
                                return (
                                    <td key={key}>{item}</td>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.rows.map((items, key) => {
                            if (items) {
                                return (
                                    <tr key={key}>
                                        {items.map((item, key) => {
                                            return (
                                                <td key={key}>{content(item)}</td>
                                            )
                                        })}
                                    </tr>
                                )
                            }
                        })}
                    </tbody>
                </table>

                {/* MOBILE */}
                {/* Turned off the mobile version of the table for now while testing overflow style */}
                {/* <div className={`Rtable Rtable--${props.data.headings.length}cols Rtable--collapse`}> */}
                {/*	{props.data.rows.map(items => { */}
                {/*		if (items) { */}
                {/*			return items.map((item, key) => { */}
                {/*					return ( */}
                {/*						<div key={key} className="Rtable-cell"> */}
                {/*							<span>{props.data.headings[key]}</span> */}
                {/*							{content(item)} */}
                {/*						</div> */}
                {/*					); */}
                {/*				} */}
                {/*			); */}
                {/*		} */}
                {/*	})} */}
                {/* </div> */}
            </div>
        </div>
    )
}

ResponsiveTable.propTypes = {
    data: PropTypes.shape({
        headings: PropTypes.array.isRequired,
        rows: PropTypes.array.isRequired
    }).isRequired,
    handleOpenModal: PropTypes.func,
    minWidthMobile: PropTypes.number
}

export default ResponsiveTable



// WEBPACK FOOTER //
// ./resources/js/components/ResponsiveTable.js